// ============================================================
// Kontakt-Popup (ersetzt die Calendly-Links)
// Öffnet sich über .js-openModalForm (btn.twig bei URL „#openModal“),
// über beliebige Links auf „#openModal“ und beim Aufruf mit #openModal in der URL.
// Absenden per AJAX an contact-form/send (Speicherung nur in der CMS).
// ============================================================

window.addEventListener('DOMContentLoaded', function () {
	const popup = document.querySelector('.js-contact-popup');
	if (!popup) return;

	const form = popup.querySelector('.js-contact-popup-form');
	const formView = popup.querySelector('.js-contact-popup-form-view');
	const thanksView = popup.querySelector('.js-contact-popup-thanks');
	const errorBox = popup.querySelector('.js-contact-popup-error');
	const submitBtn = popup.querySelector('.js-contact-popup-submit');

	const OPEN_HASH = '#openModal';
	let lastFocus = null;

	// --- öffnen / schließen ---
	function openPopup() {
		lastFocus = document.activeElement;

		// nach erfolgreichem Senden wieder mit leerem Formular starten
		if (formView.hidden) {
			form.reset();
			formView.hidden = false;
			thanksView.hidden = true;
		}

		popup.classList.add('is-active');
		popup.setAttribute('aria-hidden', 'false');
		document.body.classList.add('exit-popup-open');
		window.lenis?.stop();

		setTimeout(() => form.querySelector('input[name="fromName"]')?.focus(), 350);
	}

	function closePopup() {
		popup.classList.remove('is-active');
		popup.setAttribute('aria-hidden', 'true');
		document.body.classList.remove('exit-popup-open');
		window.lenis?.start();

		if (window.location.hash === OPEN_HASH) {
			history.replaceState(null, '', window.location.pathname + window.location.search);
		}
		lastFocus?.focus?.();
	}

	document.addEventListener('click', function (e) {
		const trigger = e.target.closest('.js-openModalForm, a[href$="' + OPEN_HASH + '"]');
		if (trigger) {
			e.preventDefault();
			openPopup();
			return;
		}
		if (e.target.closest('.js-contact-popup-close')) closePopup();
	});

	document.addEventListener('keydown', (e) => {
		if (e.key === 'Escape' && popup.classList.contains('is-active')) closePopup();
	});

	if (window.location.hash === OPEN_HASH) openPopup();

	// --- AJAX-Submit ---
	form.addEventListener('submit', async function (e) {
		e.preventDefault();
		hideError();

		const name = form.querySelector('input[name="fromName"]');
		const email = form.querySelector('input[name="fromEmail"]');
		const message = form.querySelector('textarea[name="message[body]"]');
		const consent = form.querySelector('input[name="dsgvo"]');

		if (!name.value.trim() || !email.value.trim() || !message.value.trim()) {
			showError('Bitte füllen Sie alle Felder aus.');
			return;
		}
		if (!email.checkValidity()) {
			showError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
			return;
		}
		if (consent && !consent.checked) {
			showError('Bitte stimmen Sie der Datenschutzerklärung zu.');
			return;
		}

		// Spamschutz-Token (Bots ohne JS schicken es leer)
		const token = form.querySelector('input[name="feliciaToken"]');
		if (token) token.value = token.dataset.token || '';

		submitBtn.disabled = true;
		submitBtn.classList.add('is-loading');

		try {
			const res = await fetch(window.location.pathname, {
				method: 'POST',
				headers: {
					'Accept': 'application/json',
					'X-Requested-With': 'XMLHttpRequest',
				},
				body: new FormData(form),
			});
			const data = await res.json().catch(() => ({}));

			// Craft (asModelSuccess) gibt bei Erfolg { message } ohne "success" zurück;
			// Fehler liefern { errors: {...} }. Erfolg = ok && keine Fehler.
			if (res.ok && !data.errors) {
				formView.hidden = true;
				thanksView.hidden = false;
			} else {
				const msg = data.errors
					? Object.values(data.errors).flat().join(' ')
					: (data.message || 'Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.');
				showError(msg);
			}
		} catch (err) {
			showError('Verbindungsfehler. Bitte versuchen Sie es erneut.');
		} finally {
			submitBtn.disabled = false;
			submitBtn.classList.remove('is-loading');
		}
	});

	function showError(msg) {
		errorBox.textContent = msg;
		errorBox.hidden = false;
	}

	function hideError() {
		errorBox.hidden = true;
		errorBox.textContent = '';
	}
});
